/**
 * Reusable header component for onboarding steps
 * Provides consistent styling and layout for step headings and subtitles
 */

import { useCroWeb176Experiment } from "@/src/experiments/cro-web-176/useCroWeb176Experiment";

interface OnboardingStepHeaderProps {
  heading: string;
  subtitle?: string;
  headingDataPosthog?: string;
  useExperimentSubtitle?: boolean; // Whether to use the experiment subtitle
}

const OnboardingStepHeader = ({
  heading,
  subtitle = "Help us personalise your experience",
  headingDataPosthog,
  useExperimentSubtitle = true,
}: OnboardingStepHeaderProps) => {
  const { shouldShowSubtitle } = useCroWeb176Experiment();

  // Use experiment visibility if enabled, otherwise show the provided subtitle
  const shouldDisplay = useExperimentSubtitle ? shouldShowSubtitle : true;
  const displaySubtitle = shouldDisplay ? subtitle : null;
  return (
    <div className="mb-6 flex flex-col gap-y-2 md:gap-y-4">
      <h2
        className="text-balance font-spatial text-xl font-medium md:text-3xl"
        data-posthog={headingDataPosthog}
      >
        {heading}
      </h2>

      {displaySubtitle && (
        <div className="font-body text-sm text-zinc-600 md:text-lg">
          {displaySubtitle}
        </div>
      )}
    </div>
  );
};

export default OnboardingStepHeader;
